import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {
  title = "";
  errorMessage = "";
  warning = true;
  constructor(private  dialogRef:  MatDialogRef<ConfirmModalComponent>, @Inject(MAT_DIALOG_DATA) public  data:  any) {
    this.title = data?.title;
    this.errorMessage = data?.message;
    this.warning = data?.warning;
  }
  public  closeMe() {
      this.dialogRef.close();
  }

  ngOnInit(): void {
  }

}
